"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompileMaskRecordSchema = exports.TemplateRecordSchema = exports.ImageRecordSchema = exports.ImplementationRecordSchema = exports.ImplementationListRecordSchema = exports.SignalHarnessRecordSchema = exports.HarnessTypeRecordSchema = exports.HarnessEntryRecordSchema = exports.HarnessConnectorRecordSchema = exports.RoundRectangleRecordSchema = exports.EllipticalArcRecordSchema = exports.EllipseRecordSchema = exports.PolygonRecordSchema = exports.ArcRecordSchema = exports.BezierRecordSchema = exports.FileNameRecordSchema = exports.SheetNameRecordSchema = exports.LabelRecordSchema = exports.SheetRecordSchema = exports.PortRecordSchema = exports.SheetEntryRecordSchema = exports.SheetSymbolRecordSchema = exports.JunctionRecordSchema = exports.TextFrameRecordSchema = exports.ParameterRecordSchema = exports.PowerPortRecordSchema = exports.DesignatorRecordSchema = exports.PolylineRecordSchema = exports.RectangleRecordSchema = exports.LineRecordSchema = exports.NetLabelRecordSchema = exports.BusEntryRecordSchema = exports.BusRecordSchema = exports.WireRecordSchema = exports.PinRecordSchema = exports.ComponentRecordSchema = exports.HeaderRecordSchema = void 0;
exports.isHeaderRecord = isHeaderRecord;
const zod_1 = require("zod");
const SchDocTypes_1 = require("../SchDocTypes");
const CoordinateConverter_1 = require("../parse/CoordinateConverter");
const AltiumEnums_1 = require("../../common/AltiumEnums");
const PropertyParser_1 = require("../parse/PropertyParser");
exports.HeaderRecordSchema = zod_1.z
    .object({
    recordType: zod_1.z.literal(SchDocTypes_1.RecordType.HEADER),
    index: zod_1.z.number(),
    ownerIndex: zod_1.z.number(),
    properties: PropertyParser_1.AltiumPropertiesSchema,
    majorVersion: zod_1.z.string(),
    minorVersion: zod_1.z.string(),
    header: zod_1.z.string(),
})
    .strict();
function isHeaderRecord(record) {
    return record.recordType === SchDocTypes_1.RecordType.HEADER;
}
exports.ComponentRecordSchema = zod_1.z
    .object({
    recordType: zod_1.z.literal(SchDocTypes_1.RecordType.COMPONENT),
    index: zod_1.z.number(),
    ownerIndex: zod_1.z.number(),
    properties: PropertyParser_1.AltiumPropertiesSchema,
    allPinCount: zod_1.z.number().optional(),
    componentDescription: zod_1.z.string(),
    componentkind: AltiumEnums_1.ComponentKindSchema.optional(),
    unrecognizedComponentKind: zod_1.z.number().optional(),
    currentPartId: zod_1.z.number(),
    designItemId: zod_1.z.string().optional(),
    displayMode: zod_1.z.number(),
    displayModeCount: zod_1.z.number(),
    isMirrored: zod_1.z.boolean(),
    itemGuid: zod_1.z.string().optional(),
    libReference: zod_1.z.string(),
    location: CoordinateConverter_1.AltiumCoordinateSchema,
    orientation: AltiumEnums_1.OrientationSchema,
    ownerPartId: zod_1.z.string().optional(),
    partCount: zod_1.z.number(),
    partIdLocked: zod_1.z.boolean().optional(),
    revisionGuid: zod_1.z.string().optional(),
    sourceLibraryName: zod_1.z.string(),
    symbolItemGuid: zod_1.z.string().optional(),
    symbolRevisionGuid: zod_1.z.string().optional(),
    symbolVaultGuid: zod_1.z.string().optional(),
    targetFileName: zod_1.z.string().optional(),
    uniqueId: zod_1.z.string(),
    vaultGuid: zod_1.z.string().optional(),
})
    .strict();
exports.PinRecordSchema = zod_1.z
    .object({
    recordType: zod_1.z.literal(SchDocTypes_1.RecordType.PIN),
    index: zod_1.z.number(),
    ownerIndex: zod_1.z.number(),
    properties: PropertyParser_1.AltiumPropertiesSchema,
    name: zod_1.z.string(),
    designator: zod_1.z.string(),
    location: CoordinateConverter_1.AltiumCoordinateSchema,
    pinLength: zod_1.z.number(),
    orientation: AltiumEnums_1.OrientationSchema,
    electrical: AltiumEnums_1.ElectricalTypeSchema,
    hidden: zod_1.z.boolean(),
    showPinName: zod_1.z.boolean(),
    showDesignator: zod_1.z.boolean(),
    locked: zod_1.z.boolean(),
    ownerPartId: zod_1.z.number(),
    ownerPartDisplayMode: zod_1.z.number(),
})
    .strict();
exports.WireRecordSchema = zod_1.z
    .object({
    recordType: zod_1.z.literal(SchDocTypes_1.RecordType.WIRE),
    index: zod_1.z.number(),
    ownerIndex: zod_1.z.number(),
    properties: PropertyParser_1.AltiumPropertiesSchema,
    points: zod_1.z.array(CoordinateConverter_1.AltiumCoordinateSchema),
    lineWidth: zod_1.z.number(),
})
    .strict();
exports.BusRecordSchema = zod_1.z
    .object({
    recordType: zod_1.z.literal(SchDocTypes_1.RecordType.BUS),
    index: zod_1.z.number(),
    ownerIndex: zod_1.z.number(),
    properties: PropertyParser_1.AltiumPropertiesSchema,
    points: zod_1.z.array(CoordinateConverter_1.AltiumCoordinateSchema),
    lineWidth: zod_1.z.number(),
})
    .strict();
exports.BusEntryRecordSchema = zod_1.z
    .object({
    recordType: zod_1.z.literal(SchDocTypes_1.RecordType.BUS_ENTRY),
    index: zod_1.z.number(),
    ownerIndex: zod_1.z.number(),
    properties: PropertyParser_1.AltiumPropertiesSchema,
    location: CoordinateConverter_1.AltiumCoordinateSchema,
    corner: CoordinateConverter_1.AltiumCoordinateSchema,
})
    .strict();
exports.NetLabelRecordSchema = zod_1.z
    .object({
    recordType: zod_1.z.literal(SchDocTypes_1.RecordType.NET_LABEL),
    index: zod_1.z.number(),
    ownerIndex: zod_1.z.number(),
    properties: PropertyParser_1.AltiumPropertiesSchema,
    text: zod_1.z.string(),
    location: CoordinateConverter_1.AltiumCoordinateSchema,
    orientation: AltiumEnums_1.OrientationSchema,
    fontId: zod_1.z.number(),
    justification: AltiumEnums_1.LabelJustificationSchema,
})
    .strict();
exports.LineRecordSchema = zod_1.z
    .object({
    recordType: zod_1.z.literal(SchDocTypes_1.RecordType.LINE),
    index: zod_1.z.number(),
    ownerIndex: zod_1.z.number(),
    properties: PropertyParser_1.AltiumPropertiesSchema,
    startLocation: CoordinateConverter_1.AltiumCoordinateSchema,
    endLocation: CoordinateConverter_1.AltiumCoordinateSchema,
    lineWidth: zod_1.z.number(),
    color: AltiumEnums_1.ColorSchema,
    ownerPartId: zod_1.z.number().optional(),
    ownerPartDisplayMode: zod_1.z.number().optional(),
})
    .strict();
exports.RectangleRecordSchema = zod_1.z
    .object({
    recordType: zod_1.z.literal(SchDocTypes_1.RecordType.RECTANGLE),
    index: zod_1.z.number(),
    ownerIndex: zod_1.z.number(),
    properties: PropertyParser_1.AltiumPropertiesSchema,
    topLeft: CoordinateConverter_1.AltiumCoordinateSchema,
    bottomRight: CoordinateConverter_1.AltiumCoordinateSchema,
    lineWidth: zod_1.z.number(),
    color: AltiumEnums_1.ColorSchema,
    fillColor: AltiumEnums_1.ColorSchema,
    isSolid: zod_1.z.boolean(),
    isTransparent: zod_1.z.boolean(),
    isNotAccesible: zod_1.z.boolean(),
    indexInSheet: zod_1.z.number(),
    ownerPartId: zod_1.z.number(),
    ownerPartDisplayMode: zod_1.z.number(),
    uniqueId: zod_1.z.string(),
})
    .strict();
exports.PolylineRecordSchema = zod_1.z
    .object({
    recordType: zod_1.z.literal(SchDocTypes_1.RecordType.POLYLINE),
    index: zod_1.z.number(),
    ownerIndex: zod_1.z.number(),
    properties: PropertyParser_1.AltiumPropertiesSchema,
    points: zod_1.z.array(CoordinateConverter_1.AltiumCoordinateSchema),
    lineWidth: zod_1.z.number(),
    color: AltiumEnums_1.ColorSchema,
    isNotAccesible: zod_1.z.boolean(),
    indexInSheet: zod_1.z.number(),
    ownerPartId: zod_1.z.number(),
    ownerPartDisplayMode: zod_1.z.number().optional(),
    lineShapeSize: zod_1.z.number(),
    uniqueId: zod_1.z.string(),
})
    .strict();
exports.DesignatorRecordSchema = zod_1.z
    .object({
    recordType: zod_1.z.literal(SchDocTypes_1.RecordType.DESIGNATOR),
    index: zod_1.z.number(),
    ownerIndex: zod_1.z.number(),
    properties: PropertyParser_1.AltiumPropertiesSchema,
    name: zod_1.z.string(),
    text: zod_1.z.string(),
    location: CoordinateConverter_1.AltiumCoordinateSchema,
    orientation: AltiumEnums_1.OrientationSchema,
    justification: AltiumEnums_1.JustificationSchema,
    fontId: zod_1.z.number(),
})
    .strict();
exports.PowerPortRecordSchema = zod_1.z
    .object({
    recordType: zod_1.z.literal(SchDocTypes_1.RecordType.POWER_PORT),
    index: zod_1.z.number(),
    ownerIndex: zod_1.z.number(),
    properties: PropertyParser_1.AltiumPropertiesSchema,
    text: zod_1.z.string(),
    location: CoordinateConverter_1.AltiumCoordinateSchema,
    orientation: AltiumEnums_1.PortOrientationSchema,
    style: AltiumEnums_1.PowerPortStyleSchema,
    showNetName: zod_1.z.boolean(),
    isCrossSheetConnector: zod_1.z.boolean(),
})
    .strict();
exports.ParameterRecordSchema = zod_1.z
    .object({
    recordType: zod_1.z.literal(SchDocTypes_1.RecordType.PARAMETER),
    index: zod_1.z.number(),
    ownerIndex: zod_1.z.number(),
    properties: PropertyParser_1.AltiumPropertiesSchema,
    name: zod_1.z.string(),
    text: zod_1.z.string(),
    location: CoordinateConverter_1.AltiumCoordinateSchema,
    orientation: AltiumEnums_1.OrientationSchema,
    justification: AltiumEnums_1.JustificationSchema,
    isHidden: zod_1.z.boolean(),
    isMirrored: zod_1.z.boolean(),
    isShowName: zod_1.z.boolean(),
    fontId: zod_1.z.number(),
})
    .strict();
exports.TextFrameRecordSchema = zod_1.z
    .object({
    recordType: zod_1.z.literal(SchDocTypes_1.RecordType.TEXT_FRAME),
    index: zod_1.z.number(),
    ownerIndex: zod_1.z.number(),
    properties: PropertyParser_1.AltiumPropertiesSchema,
    location: CoordinateConverter_1.AltiumCoordinateSchema,
    corner: CoordinateConverter_1.AltiumCoordinateSchema,
    text: zod_1.z.string(),
    fontId: zod_1.z.number(),
    isWordWrapped: zod_1.z.boolean(),
    clipToRect: zod_1.z.boolean(),
    showBorder: zod_1.z.boolean(),
    textMargin: zod_1.z.number(),
    areaColor: AltiumEnums_1.ColorSchema,
    textColor: AltiumEnums_1.ColorSchema,
    borderColor: AltiumEnums_1.ColorSchema,
    borderWidth: zod_1.z.number(),
    isSolid: zod_1.z.boolean(),
    alignment: AltiumEnums_1.TextFrameAlignmentSchema,
})
    .strict();
exports.JunctionRecordSchema = zod_1.z
    .object({
    recordType: zod_1.z.literal(SchDocTypes_1.RecordType.JUNCTION),
    index: zod_1.z.number(),
    ownerIndex: zod_1.z.number(),
    properties: PropertyParser_1.AltiumPropertiesSchema,
    location: CoordinateConverter_1.AltiumCoordinateSchema,
})
    .strict();
exports.SheetSymbolRecordSchema = zod_1.z
    .object({
    recordType: zod_1.z.literal(SchDocTypes_1.RecordType.SHEET_SYMBOL),
    index: zod_1.z.number(),
    ownerIndex: zod_1.z.number(),
    properties: PropertyParser_1.AltiumPropertiesSchema,
    location: CoordinateConverter_1.AltiumCoordinateSchema,
    xSize: zod_1.z.number(),
    ySize: zod_1.z.number(),
    isSolid: zod_1.z.boolean(),
    color: AltiumEnums_1.ColorSchema,
    areaColor: AltiumEnums_1.ColorSchema,
    lineWidth: AltiumEnums_1.LineWidthSchema,
    uniqueId: zod_1.z.string(),
})
    .strict();
exports.SheetEntryRecordSchema = zod_1.z
    .object({
    recordType: zod_1.z.literal(SchDocTypes_1.RecordType.SHEET_ENTRY),
    index: zod_1.z.number(),
    ownerIndex: zod_1.z.number(),
    properties: PropertyParser_1.AltiumPropertiesSchema,
    distanceFromTop: zod_1.z.number(),
    side: AltiumEnums_1.SheetSymbolSideSchema,
    name: zod_1.z.string(),
    harnessType: zod_1.z.string(),
    ioType: AltiumEnums_1.PortIOTypeSchema,
    style: AltiumEnums_1.PortStyleSchema,
    textFontId: zod_1.z.number(),
})
    .strict();
exports.PortRecordSchema = zod_1.z
    .object({
    recordType: zod_1.z.literal(SchDocTypes_1.RecordType.PORT),
    index: zod_1.z.number(),
    ownerIndex: zod_1.z.number(),
    properties: PropertyParser_1.AltiumPropertiesSchema,
    name: zod_1.z.string(),
    harnessType: zod_1.z.string(),
    location: CoordinateConverter_1.AltiumCoordinateSchema,
    width: zod_1.z.number(),
    height: zod_1.z.number(),
    areaColor: AltiumEnums_1.ColorSchema,
    color: AltiumEnums_1.ColorSchema,
    textColor: AltiumEnums_1.ColorSchema,
    fontId: zod_1.z.number(),
    alignment: AltiumEnums_1.PortAlignmentSchema,
    ioType: AltiumEnums_1.PortIOTypeSchema,
    style: AltiumEnums_1.PortStyleSchema,
})
    .strict();
exports.SheetRecordSchema = zod_1.z
    .object({
    recordType: zod_1.z.literal(SchDocTypes_1.RecordType.SHEET),
    index: zod_1.z.number(),
    ownerIndex: zod_1.z.number(),
    properties: PropertyParser_1.AltiumPropertiesSchema,
    fontIdCount: zod_1.z.number(),
    useCustomSheet: zod_1.z.boolean(),
    customX: zod_1.z.number(),
    customY: zod_1.z.number(),
    sheetStyle: zod_1.z.number(),
    workspaceOrientation: zod_1.z.number(),
})
    .passthrough();
exports.LabelRecordSchema = zod_1.z
    .object({
    recordType: zod_1.z.literal(SchDocTypes_1.RecordType.LABEL),
    index: zod_1.z.number(),
    ownerIndex: zod_1.z.number(),
    properties: PropertyParser_1.AltiumPropertiesSchema,
    location: CoordinateConverter_1.AltiumCoordinateSchema,
    text: zod_1.z.string(),
    fontId: zod_1.z.number(),
    isMirrored: zod_1.z.boolean(),
    justification: AltiumEnums_1.LabelJustificationSchema,
    orientation: AltiumEnums_1.OrientationSchema,
    ownerPartId: zod_1.z.number().optional(),
})
    .strict();
exports.SheetNameRecordSchema = zod_1.z
    .object({
    recordType: zod_1.z.literal(SchDocTypes_1.RecordType.SHEET_NAME),
    index: zod_1.z.number(),
    ownerIndex: zod_1.z.number(),
    properties: PropertyParser_1.AltiumPropertiesSchema,
    text: zod_1.z.string(),
    orientation: AltiumEnums_1.OrientationSchema,
    location: CoordinateConverter_1.AltiumCoordinateSchema,
    isHidden: zod_1.z.boolean(),
    fontId: zod_1.z.coerce.number(),
})
    .strict();
exports.FileNameRecordSchema = zod_1.z
    .object({
    recordType: zod_1.z.literal(SchDocTypes_1.RecordType.FILE_NAME),
    index: zod_1.z.number(),
    ownerIndex: zod_1.z.number(),
    properties: PropertyParser_1.AltiumPropertiesSchema,
    text: zod_1.z.string(),
    orientation: AltiumEnums_1.OrientationSchema,
    location: CoordinateConverter_1.AltiumCoordinateSchema,
    isHidden: zod_1.z.boolean(),
    fontId: zod_1.z.coerce.number(),
})
    .strict();
exports.BezierRecordSchema = zod_1.z
    .object({
    recordType: zod_1.z.literal(SchDocTypes_1.RecordType.BEZIER),
    index: zod_1.z.number(),
    ownerIndex: zod_1.z.number(),
    properties: PropertyParser_1.AltiumPropertiesSchema,
    points: zod_1.z.array(CoordinateConverter_1.AltiumCoordinateSchema),
    lineWidth: zod_1.z.number(),
    color: AltiumEnums_1.ColorSchema,
    ownerPartId: zod_1.z.number().optional(),
    ownerPartDisplayMode: zod_1.z.number().optional(),
})
    .strict();
exports.ArcRecordSchema = zod_1.z
    .object({
    recordType: zod_1.z.literal(SchDocTypes_1.RecordType.ARC),
    index: zod_1.z.number(),
    ownerIndex: zod_1.z.number(),
    properties: PropertyParser_1.AltiumPropertiesSchema,
    center: CoordinateConverter_1.AltiumCoordinateSchema,
    radius: zod_1.z.number(),
    startAngle: zod_1.z.number(),
    endAngle: zod_1.z.number(),
    lineWidth: zod_1.z.number(),
    color: AltiumEnums_1.ColorSchema,
    isSolid: zod_1.z.boolean(),
    areaColor: AltiumEnums_1.ColorSchema,
    ownerPartId: zod_1.z.number().optional(),
    ownerPartDisplayMode: zod_1.z.number().optional(),
})
    .strict();
exports.PolygonRecordSchema = zod_1.z
    .object({
    recordType: zod_1.z.literal(SchDocTypes_1.RecordType.POLYGON),
    index: zod_1.z.number(),
    ownerIndex: zod_1.z.number(),
    properties: PropertyParser_1.AltiumPropertiesSchema,
    points: zod_1.z.array(CoordinateConverter_1.AltiumCoordinateSchema),
    lineWidth: zod_1.z.number(),
    color: AltiumEnums_1.ColorSchema,
    isSolid: zod_1.z.boolean(),
    areaColor: AltiumEnums_1.ColorSchema,
    ownerPartId: zod_1.z.number().optional(),
    ownerPartDisplayMode: zod_1.z.number().optional(),
})
    .strict();
exports.EllipseRecordSchema = zod_1.z
    .object({
    recordType: zod_1.z.literal(SchDocTypes_1.RecordType.ELLIPSE),
    index: zod_1.z.number(),
    ownerIndex: zod_1.z.number(),
    properties: PropertyParser_1.AltiumPropertiesSchema,
    center: CoordinateConverter_1.AltiumCoordinateSchema,
    radius: zod_1.z.number(),
    secondaryRadius: zod_1.z.number(),
    lineWidth: zod_1.z.number(),
    color: AltiumEnums_1.ColorSchema,
    isSolid: zod_1.z.boolean(),
    areaColor: AltiumEnums_1.ColorSchema,
    ownerPartId: zod_1.z.number().optional(),
    ownerPartDisplayMode: zod_1.z.number().optional(),
})
    .strict();
exports.EllipticalArcRecordSchema = zod_1.z
    .object({
    recordType: zod_1.z.literal(SchDocTypes_1.RecordType.ELLIPTICAL_ARC),
    index: zod_1.z.number(),
    ownerIndex: zod_1.z.number(),
    properties: PropertyParser_1.AltiumPropertiesSchema,
    center: CoordinateConverter_1.AltiumCoordinateSchema,
    radius: zod_1.z.number(),
    secondaryRadius: zod_1.z.number(),
    startAngle: zod_1.z.number(),
    endAngle: zod_1.z.number(),
    lineWidth: zod_1.z.number(),
    color: AltiumEnums_1.ColorSchema,
    isSolid: zod_1.z.boolean(),
    areaColor: AltiumEnums_1.ColorSchema,
    ownerPartId: zod_1.z.number().optional(),
    ownerPartDisplayMode: zod_1.z.number().optional(),
})
    .strict();
exports.RoundRectangleRecordSchema = zod_1.z
    .object({
    recordType: zod_1.z.literal(SchDocTypes_1.RecordType.ROUND_RECTANGLE),
    index: zod_1.z.number(),
    ownerIndex: zod_1.z.number(),
    properties: PropertyParser_1.AltiumPropertiesSchema,
    location: CoordinateConverter_1.AltiumCoordinateSchema,
    corner: CoordinateConverter_1.AltiumCoordinateSchema,
    cornerRadius: CoordinateConverter_1.AltiumCoordinateSchema,
    lineWidth: zod_1.z.number(),
    color: AltiumEnums_1.ColorSchema,
    isSolid: zod_1.z.boolean(),
    areaColor: AltiumEnums_1.ColorSchema,
    ownerPartId: zod_1.z.number().optional(),
    ownerPartDisplayMode: zod_1.z.number().optional(),
    transparent: zod_1.z.boolean(),
    isNotAccesible: zod_1.z.boolean(),
    lineStyle: zod_1.z.number(),
})
    .strict();
exports.HarnessConnectorRecordSchema = zod_1.z
    .object({
    recordType: zod_1.z.literal(SchDocTypes_1.RecordType.HARNESS_CONNECTOR),
    index: zod_1.z.number(),
    ownerIndex: zod_1.z.number(),
    properties: PropertyParser_1.AltiumPropertiesSchema,
    location: CoordinateConverter_1.AltiumCoordinateSchema,
    xSize: zod_1.z.number(),
    ySize: zod_1.z.number(),
    lineWidth: zod_1.z.number(),
    isSolid: zod_1.z.boolean(),
    side: AltiumEnums_1.SheetSymbolSideSchema,
    primaryConnectionPosition: zod_1.z.union([zod_1.z.number(), zod_1.z.nan()]),
    color: AltiumEnums_1.ColorSchema,
    areaColor: AltiumEnums_1.ColorSchema,
})
    .strict();
exports.HarnessEntryRecordSchema = zod_1.z
    .object({
    recordType: zod_1.z.literal(SchDocTypes_1.RecordType.HARNESS_ENTRY),
    index: zod_1.z.number(),
    ownerIndex: zod_1.z.number(),
    properties: PropertyParser_1.AltiumPropertiesSchema,
    distanceFromTop: zod_1.z.number(),
    side: AltiumEnums_1.SheetSymbolSideSchema,
    name: zod_1.z.string(),
    harnessType: zod_1.z.string(),
    color: AltiumEnums_1.ColorSchema,
    areaColor: AltiumEnums_1.ColorSchema,
    textColor: AltiumEnums_1.ColorSchema,
    textFontId: zod_1.z.number(),
})
    .strict();
exports.HarnessTypeRecordSchema = zod_1.z
    .object({
    recordType: zod_1.z.literal(SchDocTypes_1.RecordType.HARNESS_TYPE),
    index: zod_1.z.number(),
    ownerIndex: zod_1.z.number(),
    properties: PropertyParser_1.AltiumPropertiesSchema,
    text: zod_1.z.string(),
    location: CoordinateConverter_1.AltiumCoordinateSchema,
    isHidden: zod_1.z.boolean(),
    color: AltiumEnums_1.ColorSchema,
    fontId: zod_1.z.number(),
})
    .strict();
exports.SignalHarnessRecordSchema = zod_1.z
    .object({
    recordType: zod_1.z.literal(SchDocTypes_1.RecordType.SIGNAL_HARNESS),
    index: zod_1.z.number(),
    ownerIndex: zod_1.z.number(),
    properties: PropertyParser_1.AltiumPropertiesSchema,
    points: zod_1.z.array(CoordinateConverter_1.AltiumCoordinateSchema),
    color: AltiumEnums_1.ColorSchema,
    lineWidth: zod_1.z.number(),
})
    .strict();
exports.ImplementationListRecordSchema = zod_1.z
    .object({
    recordType: zod_1.z.literal(SchDocTypes_1.RecordType.IMPLEMENTATION_LIST),
    index: zod_1.z.number(),
    ownerIndex: zod_1.z.number(),
    properties: PropertyParser_1.AltiumPropertiesSchema,
})
    .strict();
exports.ImplementationRecordSchema = zod_1.z
    .object({
    recordType: zod_1.z.literal(SchDocTypes_1.RecordType.IMPLEMENTATION),
    index: zod_1.z.number(),
    ownerIndex: zod_1.z.number(),
    properties: PropertyParser_1.AltiumPropertiesSchema,
    modelName: zod_1.z.string(),
    modelType: zod_1.z.string(),
    dataFile: zod_1.z.string(),
    description: zod_1.z.string(),
    isCurrent: zod_1.z.boolean(),
})
    .strict();
exports.ImageRecordSchema = zod_1.z
    .object({
    recordType: zod_1.z.literal(SchDocTypes_1.RecordType.IMAGE),
    index: zod_1.z.number(),
    ownerIndex: zod_1.z.number(),
    properties: PropertyParser_1.AltiumPropertiesSchema,
    location: CoordinateConverter_1.AltiumCoordinateSchema,
    corner: CoordinateConverter_1.AltiumCoordinateSchema,
    filename: zod_1.z.string(),
    ownerPartId: zod_1.z.number().optional(),
    ownerPartDisplayMode: zod_1.z.number().optional(),
})
    .strict();
exports.TemplateRecordSchema = zod_1.z
    .object({
    recordType: zod_1.z.literal(SchDocTypes_1.RecordType.TEMPLATE),
    index: zod_1.z.number(),
    ownerIndex: zod_1.z.number(),
    properties: PropertyParser_1.AltiumPropertiesSchema,
    filename: zod_1.z.string(),
    isNotAccesible: zod_1.z.boolean(),
})
    .strict();
exports.CompileMaskRecordSchema = zod_1.z
    .object({
    recordType: zod_1.z.literal(SchDocTypes_1.RecordType.COMPILE_MASK),
    index: zod_1.z.number(),
    ownerIndex: zod_1.z.number(),
    properties: PropertyParser_1.AltiumPropertiesSchema,
    location: CoordinateConverter_1.AltiumCoordinateSchema,
    corner: CoordinateConverter_1.AltiumCoordinateSchema,
})
    .strict();
//# sourceMappingURL=RecordTypes.js.map